import graphql__1d170a14ae8065694d6d from "./__generated__/Sidebar_sidebar.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import PageSectionSidebar from "../PageSection/PageSectionSidebar";
import AnchorTarget from "../Utils/AnchorTarget";

const Sidebar = props => {
  const sidebar = useFragment(Sidebar_sidebar, props.sidebar);

  if (!sidebar) return null;

  const { sections } = sidebar;

  return (
    <>
      {sections.edges.map(edge => {
        const className = classNames("page-section-wrapper", {
          "flex-1": edge.node.fullHeight
        });

        return (
          <div key={edge.node.id} className={className}>
            <AnchorTarget id={edge.node.domId} disableTopOffset />

            <PageSectionSidebar key={edge.node.id} pageSection={edge.node} />
          </div>
        );
      })}
    </>
  );
};

const Sidebar_sidebar = graphql__1d170a14ae8065694d6d;

export default Sidebar;
